import { useEventListener } from '@grandvisionhq/utils';

const miniCartEventType = 'mini-cart';
const dispatchMiniCartEvent = (type, lineItems)=>{
    if (window) {
        window.dispatchEvent(new CustomEvent(miniCartEventType, {
            detail: {
                type,
                lineItems
            }
        }));
    }
};
const useMiniCartListener = (handler)=>{
    return useEventListener(miniCartEventType, handler);
};

export { dispatchMiniCartEvent, miniCartEventType, useMiniCartListener };
//# sourceMappingURL=event.js.map
